import React from 'react';
import Table from '../../components/subcomponents/table'
import TableControl from '../../components/subcomponents/table_control'
import { connect } from 'react-redux'
import logs from '../../api/logs'
import notification from '../../components/subcomponents/notification'
import SubformDetails from '../../components/subcomponents/subform_details'

class Login extends React.Component{
    componentWillMount() {
        logs.log_login(function(error, response) {
            if (error) {
                notification.error(error.message);
            }
        });

    }
    render() {
        return (
            <SubformDetails title='LOG LOGIN' className="details width_100">
                <TableControl search={this.props.search_string}
                              handleSearch={this.props.handleSearch}
                              navigation={this.props.navigation}
                              handleSetRPP={this.props.handleSetRPP}
                              handleSetPage={this.props.handleSetPage}/>
                <Table name="log_login_list" table_key={'log_login_id'}
                       headers={{
                            sync_time: {label: 'Time',width: '30%'}, 
                            username: {label: 'Username',width: '50%'}, 
                            user_id: {label: 'ID',width: '20%'}
                        }}
                       data={this.props.log_list}/>
            </SubformDetails>
        )
    }
}

function mapStateToProps(state) {
    let log = state.logsR.log_login;
    return {
        search_string: log.search_string,
        navigation: log.list_pagination,
        log_list: log.list,

    }
}

function mapDispatchToProps(dispatch) {
    return({
        handleSearch(result) {
            dispatch({
                type: "LOG_LOGIN_UPDATE_SEARCH_STRING",
                value: result.value
            });
            logs.log_login(function(error, response) {
                if (error) {
                    notification.error(error.message);
                }
            });
        },
        handleSetRPP(result) {
            dispatch({
                type: 'LOG_LOGIN_RPP_CHANGED',
                value: result.value
            });
            logs.log_login(function(error, response) {
                if (error) {
                    notification.error(error.message);
                }
            });
        },
        handleSetPage(value) {
            dispatch({
                type: 'LOG_LOGIN_SET_PAGE',
                value: value
            });
            logs.log_login(function(error, response) {
                if (error) {
                    notification.error(error.message);
                }
            });
        }
    })
}

export default Login = connect(
    mapStateToProps, mapDispatchToProps)(
    Login
);